import { Images } from "@assets/images";

function PaymentPolicy() {
  return (
    <div className="bg-gray-100 min-h-screen flex justify-center py-8">
      <div className="px-10 py-8 bg-white shadow-md rounded-lg max-w-screen-lg mx-auto">
        <div className="flex justify-center mb-8">
          <img
            className="w-2/3 md:w-1/3"
            src={Images.LogoText.default}
            alt="Logo"
          />
        </div>
        <h1 className="text-3xl font-bold mb-4 text-gray-800 text-center">
          Chính sách thanh toán
        </h1>
        <p className=" text-gray-600 ">
          <p className="my-2">
            Có 2 hình thức thanh toán, khách hàng có thể lựa chọn hình thức
            thuận tiện và phù hợp với mình nhất:
          </p>
          <p className="my-2">
            Cách 1: Thanh toán qua cổng thanh toán được tích hợp trên website và
            ứng dụng
          </p>
          <p className="my-2">
            Cách 2: Chuyển khoản vào tài khoản công ty: Quý khách chuyển khoản
            vào tài khoản công ty của chúng tôi
          </p>
          <p className="my-2 font-bold">Thông tin tài khoản :</p>
          <p className="my-2 font-bold">
            Ngân hàng: Ngân hàng Ngoại Thương Việt Nam Vietcombank
          </p>
          <p className="my-2 font-bold">
            Chủ tài khoản: CÔNG TY CỔ PHẦN BOOKAS
          </p>
          <p className="my-2 font-bold">Số tài khoản: 1072119999</p>
          <p className="my-2">Lưu ý:</p>
          <p className="my-2">
            Nội dung chuyển khoản : ghi rõ <strong>Số điện thoại</strong> hoặc{" "}
            <strong>Số đơn hàng</strong>{" "}
          </p>
          <p className="my-2">
            Sau khi chuyển khoản, chúng tôi sẽ liên hệ xác nhận và tiến hành xác
            nhận qua tài khoản của Khách hàng
          </p>

          <p className="my-2">
            Nếu sau thời gian thỏa thuận mà chúng tôi không giao hàng hoặc không
            phản hồi lại, quý khách có thể gửi khiếu nại trực tiếp qua
            0931814258
          </p>
          <p className="my-2 font-bold">
            Chúng tôi cam kết kinh doanh minh bạch, hợp pháp, bán hàng chất
            lượng, có nguồn gốc
          </p>
        </p>
      </div>
    </div>
  );
}

export default PaymentPolicy;
